module.exports = __webpack_public_path__ + "img/arm.9b3a4770.svg";